import { wrapWithCallOnce } from '../wrapWithCallOnce';

import { logEvent } from './logEvent';

export const logEventOnceCacheMap = new Map<string, string>();
export const logEventOnce = wrapWithCallOnce(logEvent, {
  argsToKeyFn: (eventName) => eventName,
  cacheMap: logEventOnceCacheMap,
});
